/**
 * Author entry relative dates (CDN-1732).
 *
 * Upgrades server-rendered absolute dates to relative phrasing on the client,
 * so the markup stays cache-safe (the server output is correct for any visitor
 * and any cache TTL; this only refines "today"/"yesterday" against the user's
 * local clock).
 *
 * For each [data-tvk-reldate] <time> element:
 *   - same calendar day as now  -> "{today} HH:MM"
 *   - previous calendar day     -> "{yesterday} HH:MM"
 *   - otherwise                 -> leave the server-rendered absolute text
 *
 * Localized "today"/"yesterday" strings are read from data-label-today /
 * data-label-yesterday on the element (set in PHP), avoiding new JS globals.
 * Time is formatted 24h as HH:MM. Invalid dates are left untouched.
 */
(function () {
	"use strict";

	function pad2(n) {
		return n < 10 ? "0" + n : String(n);
	}

	function sameCalendarDay(a, b) {
		return (
			a.getFullYear() === b.getFullYear() &&
			a.getMonth() === b.getMonth() &&
			a.getDate() === b.getDate()
		);
	}

	function upgrade(el) {
		var iso = el.getAttribute("datetime");
		if (!iso) {
			return;
		}

		var date = new Date(iso);
		if (isNaN(date.getTime())) {
			// Invalid date — leave the server-rendered text as-is.
			return;
		}

		var now = new Date();
		var yesterday = new Date(now.getTime());
		yesterday.setDate(now.getDate() - 1);

		var label = null;
		if (sameCalendarDay(date, now)) {
			label = el.getAttribute("data-label-today");
		} else if (sameCalendarDay(date, yesterday)) {
			label = el.getAttribute("data-label-yesterday");
		}

		if (!label) {
			// Not today/yesterday — keep the absolute date.
			return;
		}

		var time = pad2(date.getHours()) + ":" + pad2(date.getMinutes());
		el.textContent = label + " " + time;
	}

	function init() {
		var nodes = document.querySelectorAll("[data-tvk-reldate]");
		for (var i = 0; i < nodes.length; i++) {
			upgrade(nodes[i]);
		}
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
})();
